import { AVAILABLE_SPECIALITIES } from '@/modules/MedicalSpecialities/constants'
import { IClinic } from '@/modules/Auth/auth-types'

export const extract = (fields, object) => {
  return fields.reduce((items, field) => {
    if (object[field]) {
      items[field] = object[field]
      return items
    }
    items[field] = null
    return items
  }, {})
}

export class Speciality {
  private _immediatePrice = 0
  private _scheduledPrice = 0
  private _description: string

  // eslint-disable-next-line no-useless-constructor
  constructor(
    private readonly _id: string,
    private readonly _name: string,
    _description: string,
    private readonly _enabled: boolean,
    private readonly _immediate: boolean,
    private readonly _scheduled: boolean,
    private readonly _manual: boolean,
    private readonly _automatic: boolean,
    private readonly _councilType: string,
  ) {
    this._description = _description.split('/')[0] || _description
  }

  get name(): string {
    return this._name
  }

  get id(): string {
    return this._id
  }

  get description(): string {
    return this._description
  }

  get immediatePrice(): number {
    return this._immediatePrice
  }

  set immediatePrice(price: number) {
    this._immediatePrice = price
  }

  get scheduledPrice(): number {
    return this._scheduledPrice
  }

  set scheduledPrice(price: number) {
    this._scheduledPrice = price
  }

  get automatic(): boolean {
    return this._automatic
  }

  get manual(): boolean {
    return this._manual
  }

  isEnabled(): boolean {
    return this._enabled && (this._immediate || this._scheduled)
  }

  canSearchMedic(clinicId: number): boolean {
    return this.id === 'MEDICO' && clinicId !== 2133 && this._manual
  }

  get canShowImmediatelyMedicModal(): boolean {
    return this._id === 'MEDICO'
  }

  get canSchedule(): boolean {
    return this._scheduled
  }

  get canImmediately(): boolean {
    return this._immediate
  }

  get councilType(): string {
    return this._councilType
  }
}

/**
 *  "id" : "ENFERMEIRO",
 "habilitado" : true,
 "atendimentoImediato" : true,
 "atendimentoAgendado" : true,
 "descricao" : "Enfermeiro(a)",
 "servicoAgendamentoManual" : true,
 "servicAgendamentoAutomatico" : true,
 "servicoMedicoEspecialistaManual" : true,
 "servicoMedicoEspecialistaAutomatico" : true
 *
 * @param {Object} clinic
 * @return {Speciality[]}
 */
export const buildSpecialitiesFromClinic = (clinic: IClinic): Speciality[] => {
  const specialities = extract(AVAILABLE_SPECIALITIES, clinic)
  return AVAILABLE_SPECIALITIES?.map(name => {
    return new Speciality(
      specialities[name]?.id,
      specialities[name]?.id,
      specialities[name]?.descricao,
      specialities[name]?.habilitado,
      specialities[name]?.atendimentoImediato,
      specialities[name]?.atendimentoAgendado,
      specialities[name]?.servicoMedicoEspecialistaManual,
      specialities[name]?.servicoMedicoEspecialistaAutomatico,
      specialities[name]?.tipoConselho,
    )
  })
}
